import { render, staticRenderFns } from "./SurveyManagementPreviewWrapper.vue?vue&type=template&id=70b5a877&scoped=true&"
import script from "./SurveyManagementPreviewWrapper.vue?vue&type=script&lang=js&"
export * from "./SurveyManagementPreviewWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SurveyManagementPreviewWrapper.vue?vue&type=style&index=0&id=70b5a877&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70b5a877",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/RXxibax4-/0/opiniooon/opnn-analytics/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70b5a877')) {
      api.createRecord('70b5a877', component.options)
    } else {
      api.reload('70b5a877', component.options)
    }
    module.hot.accept("./SurveyManagementPreviewWrapper.vue?vue&type=template&id=70b5a877&scoped=true&", function () {
      api.rerender('70b5a877', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/survey-management/edit-question/question-preview/SurveyManagementPreviewWrapper.vue"
export default component.exports